module.exports = __webpack_public_path__ + "static/media/twinFigure.0cbb62d6.jpg";